import type { PassionateGuide } from '@/shared/api/experience';

/** Поля карточки гида в блоке `guides_info` (без `description` из токенов). */
export function mapApiGuideForRelatedCard(api: PassionateGuide) {
  return {
    id: Number(api.id),
    name: String(api.first_name ?? ''),
    avatarLink: api.avatar_url ?? '',
    determination: api.determination,
    location: String(api.determination ?? ''),
    rating: Number(api.rating ?? 0),
    reviews: Number(api.reviews_count ?? 0),
  };
}

/** Базовые поля гида для цитаты в блоке `guides_quotes`. */
export function mapApiGuideForQuotes(api: PassionateGuide) {
  return {
    id: Number(api.id),
    name: String(api.first_name ?? ''),
    avatarLink: api.avatar_url ?? '',
    location: String(api.determination ?? ''),
    experienceCount: Number(api.reviews_count ?? 0),
  };
}
